import React, { useEffect } from 'react';
import { Button, Card, Col, Container, Row } from 'react-bootstrap';

import { items } from '../integrationItems';
import styles from './IntegrationMain.module.scss';
import Image from '../../core-components/Image';
import { useState } from 'react';
import AccessRequiredModal from './RequestModals/AccessRequiredModal.jsx';
import RequestReceivedModal from './RequestModals/RequestReceivedModal';
import { integrationRequestWebhookUrlApi } from '../../../../../api/company';
import cn from 'classnames';
import { getErrorMessage } from '../../core-components/Utilities/utilities';
import StatusTag from '../Utils/StatusTag';
const innerHtml = (html) => {
  return { __html: html };
};

const IntegrationMain = (props) => {
  const { profile } = props.profile;
  const [isRequestReqModalOpen, setIsRequestReqModalOpen] = useState(false);
  const [isRequestRecModalOpen, setIsRequestRecModalOpen] = useState(false);
  const [title, setTitle] = useState('');
  const companyId = new URLSearchParams(document.location.search).get('company_id') || null;

  const getButton = (index, id) => {
    switch (index) {
      case 0:
      case 1:
      case 2:
      case 3:
      case 4:
        return (
          <Button
            className={`${isConnected(index) ? styles.configureButton : styles.connectButton}`}
            onClick={() => {
              props.history.push(`/integrations/${id}`);
            }}
          >
            {isConnected(index) ? 'Configure' : 'Connect'}
          </Button>
        );
      default:
        return <div className={styles.comingSoon}>Coming Soon</div>;
    }
  };

  const isConnected = (index) => {
    switch (index) {
      case 0:
        return props.integrationData?.razorpayX?.apiKey;
      case 1:
        return (
          props.integrationData?.greenhouse?.apiKey &&
          props.integrationData?.greenhouse?.webhookEnabled
        );
      case 2:
        return props.integrationData?.lever?.refreshToken;
      case 3:
        return props.integrationData?.zohoRecruit?.token;
      case 4:
        return (
          props.integrationData?.recruitee?.token &&
          props.integrationData?.recruitee?.webhookEnabled
        );
      default:
        return false;
    }
  };

  return (
    <>
      <Container>
        <Row className='mt-4'>
          {items.map((it, index) => (
            <Col key={`${it.title}_index`} sm={4} className='mb-5'>
              <Card className={styles.wrapper}>
                <Card.Body>
                  <div className={styles.bodyHeader}>
                    <Image width={'60px'} height={'60px'} name={it.icon} />
                    <StatusTag show={isConnected(index)} />
                  </div>
                  <p className={styles.title}>{it.title}</p>
                  <p className={cn('text-secondary', styles.subtitle)}>{it.subtitle}</p>
                  <p
                    className={styles.bodyText}
                    dangerouslySetInnerHTML={innerHtml(it?.details)}
                  ></p>
                  <div className='mt-5'>{getButton(index, it.id)}</div>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
        {/* {isRequestReqModalOpen ? (
          <AccessRequiredModal
            show={isRequestReqModalOpen}
            onHide={() => {
              setIsRequestReqModalOpen(false);
            }}
            title={title}
            onConfirm={() => {
              setIsRequestReqModalOpen(false);
              const data = {
                companyId,
                email: profile?.email,
                ca_name: profile?.name,
                ca_id: profile?.id,
                phone: profile?.mobile,
                company_name: profile?.company_user_mapping?.company?.name,
                company_id: profile?.company_user_mapping?.company?.id,
                type: title
              };
              integrationRequestWebhookUrlApi(data)
                .then(() => {
                  // Storing in the local storage for checking whether integration is requested or not since there is no API for it
                  localStorage.setItem(`${title}IntegrationRequested`, 1);
                  setIsRequestRecModalOpen(true);
                })
                .catch((err) => {
                  toast.error(getErrorMessage(err));
                });
            }}
          />
        ) : null} */}
        {/* {isRequestRecModalOpen ? (
          <RequestReceivedModal
            show={isRequestRecModalOpen}
            onHide={() => {
              setIsRequestRecModalOpen(false);
            }}
            title={title}
            onConfirm={() => {
              setIsRequestRecModalOpen(false);
            }}
          />
        ) : null} */}
      </Container>
    </>
  );
};

export default IntegrationMain;
